import React from "react";
import { useState,useEffect } from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { CREATE_TRIVVY_MODAL_IMAGES, minPlanLimitCheck } from "../../data";
import "./createTrivia.css";
import CreateTriviaPopup from "./CreateTriviaPopup";
import TrivvyTemplatesModalMain from "./TrivvyTemplatesModalMain";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import CheckBox from "rc-checkbox";
import axios from "../../../../axios";
import * as url from "../../../../utils/url";
import * as actionCreators from "../../../../modules/actions";
import ScheduleQuestionsModal from "../../LibraryModule/Components/ScheduleQuestionsModal";
import ScheduleQuestionsModalWrapper from "../../LibraryModule/Components/ScheduleQuestionsModalWrapper";
import CreateCustomTrivvyPopup from "./CreateCustomTrivvyPopup";
// src/assets/create-trivvy-modal/templates-trivvy.png
import templatesTrivvy from '../../../../assets/create-trivvy-modal/templates-trivvy.png'
import trivvyQuestionsBank from '../../../../assets/create-trivvy-modal/trivvy-question-bank.png'
import workWithAi from '../../../../assets/create-trivvy-modal/work-with-ai.png'

function CreateTriviaModalMain(props) {
  const [selectedType, setSelectedType] = useState(null);

  const user = props.user;

  useEffect(() => {
    if(props.onlyShowMessageWindow){
      setSelectedType(5)
    }
  }, [])
  

  const handleUpdateFlag = (val) => {
    axios
      .post(url.updateTrivvyModalFlag, {
        hideCreateTrivvyModal: val,
      })
      .then((data) => {
        props.updateUserSuccess({
          ...user.profile,
          hideCreateTrivvyModal: val,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <Modal isOpen={props.open} className="create-trivvy-modal-main-popup-css">
      <ModalHeader className="trivia_modal_header_bg" toggle={props.onClose}>
        {selectedType === 1
          ? "Custom Trivvy"
          : selectedType === 2
          ? "Smart Trivvy generated by AI"
          : selectedType === 3
          ? "Trivvy templates "
          : selectedType == 4
          ? "Built with AI"
          : selectedType == 5
          ? "Messaging"
          : "Create New Trivvy"}
      </ModalHeader>
      <ModalBody className="pt-3 px-4 pb-0">
        {selectedType == null ? (
          <div>
            <div>
              {/* <div className="my-2 trivvy-create-popup-title">
                {!props.canCreateRewards && props.firstTimePopupText ? (
                  props.firstTimePopupText
                ) : (
                  <span>
                    Select one of the options below to create your trivvy{" "}
                  </span>
                )}
                {props.canCreateRewards ? (
                  <span>
                    {" "}
                    or{" "}
                    <span
                      className="text-info cursor-pointer"
                      onClick={() => {
                        if (props.goToRewards) {
                          props.goToRewards();
                        }
                      }}
                    >
                      create a reward
                    </span>{" "}
                    for your trivvys{" "}
                  </span>
                ) : (
                  ""
                )}
              </div> */}

              <div className="mt-4 trivvy-create-options-list">
                <div
                  className="trivvy-create-option-card qb-create"
                  onClick={() => setSelectedType(4)}
                >
                  <img
                    // src={
                    //   "https://dev-oo-app-api.s3.us-east-2.amazonaws.com/trivvy-question-bank.png"
                    // }
                    src={templatesTrivvy}
                    className="trivvy-create-option-card-img"
                  />
                  <div className="trivvy-create-option-card-txt">
                    {" "}
                    <b>Survey Generator:</b> Type in what you need to find out,
                    and let AI generate your pulse survey
                  </div>
                </div>

                <div
                  className="trivvy-create-option-card template-create"
                  onClick={() => setSelectedType(5)}
                >
                  <img
                    // src="https://dev-oo-app-api.s3.us-east-2.amazonaws.com/templates-trivvy.png"
                    src={templatesTrivvy}
                    className="trivvy-create-option-card-img"
                  />
                  <div className="trivvy-create-option-card-txt">
                    {" "}
                    <b>Messaging:</b> Send announcements, messages, alerts or any other type of communication, and get real-time analytics on responses
                  </div>
                </div>
                <div
                  className="trivvy-create-option-card ai-create"
                  onClick={() => setSelectedType(2)}
                >
                  <img
                    src={workWithAi}
                    className="trivvy-create-option-card-img"
                  />
                  <div className="trivvy-create-option-card-txt">
                    {" "}
                    <b>Knowledge Checks:</b> Use AI to auto generate and
                    schedule one or more assessments from any content in under a
                    minute
                  </div>
                </div>
                {/* <div
                className="trivvy-create-option-card custom-create"
                onClick={() => setSelectedType(1)}
              >
                <img
                  src={CREATE_TRIVVY_MODAL_IMAGES.CUSTOM}
                  className="trivvy-create-option-card-img"
                />
                <div className="trivvy-create-option-card-txt">
                  {" "}
                  <b>Create manual survey:</b> Create a custom survey with your own questions.
                </div>
              </div> */}

                {/* <div
                className="trivvy-create-option-card ai-create"
                onClick={() => setSelectedType(2)}
              >
                <img
                  src={CREATE_TRIVVY_MODAL_IMAGES.AI}
                  className="trivvy-create-option-card-img"
                />
                <div className="trivvy-create-option-card-txt">
                  {" "}
                  <b>AI-generated trivvys</b> in under a minute from any
                  document, link or text
                </div>
              </div> */}

                {/* <div
                className="trivvy-create-option-card custom-create"
                onClick={() => setSelectedType(3)}
              >
                <img
                  src={CREATE_TRIVVY_MODAL_IMAGES.CUSTOM}
                  className="trivvy-create-option-card-img"
                />
                <div className="trivvy-create-option-card-txt">
                  <b>Feedback Templates:</b> Use ready made templates to get feedback from your customers or employees
                </div>
              </div> */}

                {/* 
              <div
                className="trivvy-create-option-card qb-create"
                onClick={() => {
                  if (props.history) {
                    props.history.push(
                      `/home/trivia/${user.profile.organizationId._id}/library`
                    );
                  }
                }}
              >
                <img
                  src="https://dev-oo-app-api.s3.us-east-2.amazonaws.com/trivvy-question-bank.png"
                  className="trivvy-create-option-card-img"
                />
                <div className="trivvy-create-option-card-txt">
                  {" "}
                  Create and auto schedule several Trivvys from longer content
                  in the <b>Library</b>
                </div>
              </div> */}
              </div>
            </div>
            <div className="my-3" style={{
              width:"75%",
              margin:"0px auto"
            }}>
              <div
                className="link-text"
                onClick={() => {
                  setSelectedType(1);
                }}
              >
                Create manual survey
              </div>
            </div>
          </div>
        ) : (
          <div>
            {selectedType === 1 ? (
              <CreateCustomTrivvyPopup
                uiType="INLINE"
                {...props}
                autoSelectedTrivvyType={"CUSTOM"}
                onBack={() => setSelectedType(null)}
              />
            ) : selectedType === 2 ? (
              <CreateTriviaPopup
                uiType="INLINE"
                {...props}
                autoSelectedTrivvyType={"AI"}
                onBack={() => setSelectedType(null)}
              />
            ) : selectedType === 3 ? (
              <TrivvyTemplatesModalMain
                uiType="INLINE"
                {...props}
                onBack={() => setSelectedType(null)}
              />
            ) : selectedType === 4 ? (
              <CreateTriviaPopup
                uiType="INLINE"
                onlyAllowCustomTextPrompt
                {...props}
                autoSelectedTrivvyType={"AI"}
                onBack={() => setSelectedType(null)}
              />
            ) : selectedType === 5 ? (
              <CreateCustomTrivvyPopup
                uiType="INLINE"
                {...props}
                autoSelectedTrivvyType={"CUSTOM"}
                isMessaging={true}
                onBack={() => setSelectedType(null)}
              />
            ) : (
              ""
            )}
          </div>
        )}
      </ModalBody>

      <ModalFooter>
        {!selectedType && (
          <div>
            <b>Never show again</b>
            <CheckBox
              className="ml-2"
              checked={user.profile.hideCreateTrivvyModal}
              onChange={(e) => {
                if (e.target.checked && props.setCreateModalState) {
                  props.setCreateModalState(false);
                }
                handleUpdateFlag(e.target.checked);
              }}
            />
          </div>
        )}
      </ModalFooter>
    </Modal>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateUserSuccess: (data) =>
      dispatch(actionCreators.updateUserSuccess(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CreateTriviaModalMain));
